// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\VesselChange\ApiVesselChange.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';
import { Vessel, VesselData, VesselOptions } from 'data/models/Vessel';

// VesselChangeData is the class that VesselChange serializes to/from
export interface VesselChangeData {
    Id : number;
	
    Event : EventData | null;
    EventId : number;
    Vessel : VesselData | null;
    VesselId : number;
	
    NewBowThrusterPresent : boolean | null;
    NewBowThrusterSize : NullableMeasurementData;
    OldBowThrusterPresent : boolean | null;
    OldBowThrusterSize : NullableMeasurementData;
    Type : string | null;
}

// VesselChangeOptions is the class which may be passed to the VesselChange constructor to define optional initial data values
export interface VesselChangeOptions {
    Id : number;
	
    Event? : EventOptions | null;
    EventId? : number;
    Vessel? : VesselOptions | null;
    VesselId? : number;
	
    NewBowThrusterPresent? : boolean | null;
    NewBowThrusterSize? : NullableMeasurementOptions;
    OldBowThrusterPresent? : boolean | null;
    OldBowThrusterSize? : NullableMeasurementOptions;
    Type? : string | null;
}

export class VesselChange {
    public Id : DataSignal<number>;
	
    public Event : DataSignal<Event | null>;
    public EventId : DataSignal<number>;
    public Vessel : DataSignal<Vessel | null>;
    public VesselId : DataSignal<number>;
	
    public NewBowThrusterPresent : DataSignal<boolean | null>;
    public NewBowThrusterSize : NullableMeasurement;
    public OldBowThrusterPresent : DataSignal<boolean | null>;
    public OldBowThrusterSize : NullableMeasurement;
    public Type : DataSignal<string | null>;

    constructor();
    constructor(data : VesselChangeOptions);
    constructor(data: VesselChangeOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Event = S.value<Event | null>(null);
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.Vessel = S.value<Vessel | null>(null);
        this.VesselId = jsonableObservable(S.value<number>(data && data.VesselId !== undefined ? data.VesselId : 0));
	    
        this.NewBowThrusterPresent = jsonableObservable(S.value<boolean | null>(data && data.NewBowThrusterPresent !== undefined ? data.NewBowThrusterPresent : null));
        this.NewBowThrusterSize = data && data.NewBowThrusterSize !== undefined ? new NullableMeasurement(data.NewBowThrusterSize) : new NullableMeasurement();
        this.OldBowThrusterPresent = jsonableObservable(S.value<boolean | null>(data && data.OldBowThrusterPresent !== undefined ? data.OldBowThrusterPresent : null));
        this.OldBowThrusterSize = data && data.OldBowThrusterSize !== undefined ? new NullableMeasurement(data.OldBowThrusterSize) : new NullableMeasurement();
        this.Type = jsonableObservable(S.value<string | null>(data && data.Type !== undefined ? data.Type : null));
    }

    static key(obj : VesselChange) {
        return obj.Id();
    }
    
    static dataKey(obj : VesselChangeOptions) {
        return obj.Id;
    }

    static update(obj : VesselChange, data : VesselChangeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.EventId !== undefined) obj.EventId(data.EventId);
            if (data.VesselId !== undefined) obj.VesselId(data.VesselId);
	        
            if (data.NewBowThrusterPresent !== undefined) obj.NewBowThrusterPresent(data.NewBowThrusterPresent);
            if (data.NewBowThrusterSize !== undefined) NullableMeasurement.update(obj.NewBowThrusterSize, data.NewBowThrusterSize);
            if (data.OldBowThrusterPresent !== undefined) obj.OldBowThrusterPresent(data.OldBowThrusterPresent);
            if (data.OldBowThrusterSize !== undefined) NullableMeasurement.update(obj.OldBowThrusterSize, data.OldBowThrusterSize);
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/VesselChange.ts